var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { startTabAlert } from './alertNotification';
export var SoundType;
(function (SoundType) {
    SoundType["UPDATE"] = "update";
    SoundType["ALERT"] = "alert";
})(SoundType || (SoundType = {}));
// ✅ Detecta o ambiente e retorna o caminho correto
var getSoundPath = function () {
    // Se estiver em desenvolvimento (localhost)
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return '/sounds';
    }
    // Se estiver em produção (VPS)
    return '/static/frontend/sounds';
};
// ✅ URLs corretas dos arquivos de som (adapta automaticamente ao ambiente)
var SOUND_URLS = (_a = {},
    _a[SoundType.UPDATE] = "".concat(getSoundPath(), "/update.ogg"),
    _a[SoundType.ALERT] = "".concat(getSoundPath(), "/alert.wav"),
    _a);
// ✅ Log para debug
// console.log('🔊 Ambiente detectado:', window.location.hostname);
// console.log('🔊 Caminho dos sons:', getSoundPath());
// console.log('🔊 URLs configuradas:', SOUND_URLS);
// ✅ Configuração de preferências de áudio
var STORAGE_KEY = 'visionCockpit_audioSettings';
// ✅ Carregar preferências do localStorage
export var getAudioSettings = function () {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
        try {
            return JSON.parse(stored);
        }
        catch (_a) {
            // Fallback
        }
    }
    return {
        enabled: true,
        volume: 1.0, // ✅ Volume padrão em 100%
        permissionGranted: false
    };
};
// ✅ Salvar preferências
export var setAudioSettings = function (settings) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
};
// ✅ Tocar som usando arquivos locais (COM VOLUME AMPLIFICADO)
export var playSound = function (type_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([type_1], args_1, true), Promise, function (type, forcePlay) {
        var settings, audio, error_1;
        if (forcePlay === void 0) { forcePlay = false; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    settings = getAudioSettings();
                    if (!settings.enabled && !forcePlay) {
                        // console.log(`🔇 Áudio desabilitado: ${type}`);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    audio = new Audio(SOUND_URLS[type]);
                    // ✅ VOLUME AMPLIFICADO (0.0 a 1.0 = 0% a 100%)
                    audio.volume = Math.min(settings.volume, 1.0); // Limita a 1.0 por segurança do navegador
                    return [4 /*yield*/, audio.play()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("\u274C Erro ao reproduzir som ".concat(type, ":"), error_1);
                    console.error("\u274C Caminho tentado: ".concat(SOUND_URLS[type]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
// ✅ Toggle som
export var toggleSound = function () {
    var settings = getAudioSettings();
    settings.enabled = !settings.enabled;
    setAudioSettings(settings);
    return settings.enabled;
};
// ✅ Ajustar volume (agora aceita 0 a 2)
export var setVolume = function (volume) {
    var settings = getAudioSettings();
    settings.volume = Math.max(0, Math.min(2, volume)); // ✅ Permite até 200%
    setAudioSettings(settings);
};
// ✅ Solicitar permissão de áudio (interação do usuário)
export var requestAudioPermission = function () { return __awaiter(void 0, void 0, Promise, function () {
    var audio, settings, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                audio = new Audio(SOUND_URLS[SoundType.UPDATE]);
                audio.volume = 0;
                return [4 /*yield*/, audio.play()];
            case 1:
                _a.sent();
                return [4 /*yield*/, audio.pause()];
            case 2:
                _a.sent();
                settings = getAudioSettings();
                settings.permissionGranted = true;
                setAudioSettings(settings);
                // console.log('✅ Permissão de áudio concedida');
                return [2 /*return*/, true];
            case 3:
                error_2 = _a.sent();
                console.error('❌ Erro ao solicitar permissão de áudio:', error_2);
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
var AudioAlertManager = /** @class */ (function () {
    function AudioAlertManager() {
        this.audio = null;
        this.audioContext = null;
        this.isEnabled = false;
        this.hasPermission = false;
        this.loadSettings();
    }
    AudioAlertManager.prototype.loadSettings = function () {
        var saved = localStorage.getItem('audioAlertsEnabled');
        this.isEnabled = saved === 'true';
    };
    AudioAlertManager.prototype.initialize = function () {
        return __awaiter(this, void 0, Promise, function () {
            var audioPath_1, error_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // ✅ Criar áudio com o caminho correto (adapta automaticamente)
                        this.audio = new Audio();
                        audioPath_1 = "".concat(getSoundPath(), "/alert.wav");
                        // console.log('🔊 Inicializando áudio com caminho:', audioPath);
                        this.audio.src = audioPath_1;
                        this.audio.preload = 'auto';
                        // ✅ Aguarda o áudio carregar
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                if (!_this.audio) {
                                    reject(new Error('Audio element not initialized'));
                                    return;
                                }
                                _this.audio.oncanplaythrough = function () { return resolve(true); };
                                _this.audio.onerror = function (e) {
                                    console.error('❌ Erro ao carregar áudio:', e);
                                    console.error('❌ Caminho tentado:', audioPath_1);
                                    reject(new Error('Falha ao carregar áudio'));
                                };
                                // ✅ Força o carregamento
                                _this.audio.load();
                            })];
                    case 1:
                        // ✅ Aguarda o áudio carregar
                        _a.sent();
                        // ✅ Cria AudioContext para controle avançado
                        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
                        this.hasPermission = true;
                        // console.log('✅ Sistema de áudio inicializado com sucesso');
                        return [2 /*return*/, true];
                    case 2:
                        error_3 = _a.sent();
                        console.error('❌ Erro ao inicializar sistema de áudio:', error_3);
                        this.hasPermission = false;
                        // ✅ Fallback: usa beep sintético
                        // console.log('⚠️ Usando beep sintético como fallback');
                        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
                        this.hasPermission = true; // Permite usar beep
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AudioAlertManager.prototype.requestPermission = function () {
        return __awaiter(this, void 0, Promise, function () {
            var initialized, playPromise, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, this.initialize()];
                    case 1:
                        initialized = _a.sent();
                        if (!initialized) {
                            throw new Error('Falha ao inicializar áudio');
                        }
                        if (!(this.audio && this.audio.src)) return [3 /*break*/, 4];
                        this.audio.volume = 0.01;
                        playPromise = this.audio.play();
                        if (!(playPromise !== undefined)) return [3 /*break*/, 3];
                        return [4 /*yield*/, playPromise];
                    case 2:
                        _a.sent();
                        this.audio.pause();
                        this.audio.currentTime = 0;
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4: 
                    // ✅ Testa com beep sintético
                    return [4 /*yield*/, this.playBeep(0.01)];
                    case 5:
                        // ✅ Testa com beep sintético
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        this.hasPermission = true;
                        // console.log('✅ Permissão de áudio concedida');
                        return [2 /*return*/, true];
                    case 7:
                        error_4 = _a.sent();
                        console.error('❌ Erro ao solicitar permissão de áudio:', error_4);
                        this.hasPermission = false;
                        return [2 /*return*/, false];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    AudioAlertManager.prototype.playAlert = function () {
        return __awaiter(this, void 0, Promise, function () {
            var settings, playPromise, error_5, beepError_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isEnabled || !this.hasPermission) {
                            console.warn('⚠️ Alertas de áudio desabilitados ou sem permissão');
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 9, , 14]);
                        // ✅ Inicia notificação visual na aba (se a página não estiver em foco)
                        if (document.hidden) {
                            startTabAlert('🚨 NOVO ALERTA!');
                        }
                        if (!(((_a = this.audioContext) === null || _a === void 0 ? void 0 : _a.state) === 'suspended')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.audioContext.resume()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        settings = getAudioSettings();
                        if (!(this.audio && this.audio.src)) return [3 /*break*/, 6];
                        // ✅ Volume entre 0.7 e 1.0 (limitado pelo navegador)
                        this.audio.volume = Math.min(settings.volume * 0.9, 1.0); // 90% do volume configurado (máx 100%)
                        this.audio.currentTime = 0;
                        playPromise = this.audio.play();
                        if (!(playPromise !== undefined)) return [3 /*break*/, 5];
                        return [4 /*yield*/, playPromise];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6: 
                    // ✅ Fallback para beep sintético COM VOLUME AUMENTADO
                    return [4 /*yield*/, this.playBeep(settings.volume * 0.5)];
                    case 7:
                        // ✅ Fallback para beep sintético COM VOLUME AUMENTADO
                        _b.sent(); // 50% do volume configurado
                        _b.label = 8;
                    case 8: return [3 /*break*/, 14];
                    case 9:
                        error_5 = _b.sent();
                        console.error('❌ Erro ao reproduzir alerta, tentando beep:', error_5);
                        _b.label = 10;
                    case 10:
                        _b.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, this.playBeep(0.5)];
                    case 11:
                        _b.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        beepError_1 = _b.sent();
                        console.error('❌ Erro ao reproduzir beep:', beepError_1);
                        return [3 /*break*/, 13];
                    case 13: return [3 /*break*/, 14];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    // ✅ Gera um beep usando Web Audio API (COM GANHO AUMENTADO)
    AudioAlertManager.prototype.playBeep = function () {
        return __awaiter(this, arguments, Promise, function (volume) {
            var oscillator, gainNode, finalVolume;
            if (volume === void 0) { volume = 0.5; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.audioContext) {
                            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
                        }
                        if (!(this.audioContext.state === 'suspended')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.audioContext.resume()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        oscillator = this.audioContext.createOscillator();
                        gainNode = this.audioContext.createGain();
                        oscillator.connect(gainNode);
                        gainNode.connect(this.audioContext.destination);
                        oscillator.frequency.value = 800; // Frequência do beep
                        oscillator.type = 'sine';
                        finalVolume = Math.min(volume, 1.0);
                        gainNode.gain.setValueAtTime(finalVolume, this.audioContext.currentTime);
                        gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.5);
                        oscillator.start(this.audioContext.currentTime);
                        oscillator.stop(this.audioContext.currentTime + 0.5);
                        return [2 /*return*/];
                }
            });
        });
    };
    AudioAlertManager.prototype.enable = function () {
        this.isEnabled = true;
        localStorage.setItem('audioAlertsEnabled', 'true');
    };
    AudioAlertManager.prototype.disable = function () {
        this.isEnabled = false;
        localStorage.setItem('audioAlertsEnabled', 'false');
    };
    AudioAlertManager.prototype.isAudioEnabled = function () {
        return this.isEnabled && this.hasPermission;
    };
    AudioAlertManager.prototype.getPermissionStatus = function () {
        return this.hasPermission;
    };
    return AudioAlertManager;
}());
export var audioAlertManager = new AudioAlertManager();
